module.exports = __webpack_public_path__ + "static/img/3@2x.600fe56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/barometer/3@2x.png
// module id = +9cv
// module chunks = 1